module.exports = __webpack_public_path__ + "static/media/award1.dadcf827.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/award1.png
// module id = 1345
// module chunks = 0